import { render } from "./OvApplicationView.vue?vue&type=template&id=b8335074&scoped=true"
import script from "./OvApplicationView.vue?vue&type=script&lang=js"
export * from "./OvApplicationView.vue?vue&type=script&lang=js"

import "./OvApplicationView.vue?vue&type=style&index=0&id=b8335074&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8335074"],['__file',"src/views/overlatelser/OvApplicationView/OvApplicationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8335074"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8335074', __exports__)) {
    api.reload('b8335074', __exports__)
  }
  
  module.hot.accept("./OvApplicationView.vue?vue&type=template&id=b8335074&scoped=true", () => {
    api.rerender('b8335074', render)
  })

}


export default __exports__